import axios from 'axios';
import { hosts } from 'settings';
import { camelizeKeys, decamelizeKeys } from 'humps';
import { memberStorage } from './memberStorage';

const handleRequest = config => {
  const data = decamelizeKeys(config.data);
  const headers = {
    HTTP_X_AUTH_TOKEN: window.localStorage.getItem('token'),
  };
  const params = decamelizeKeys(config.params);
  return { ...config, data, params, headers };
};

const handleResponse = response => {
  const data = response.config.skipCamelize
    ? response.data
    : camelizeKeys(response.data);
  const pagination = getPagination(response);

  return { ...response, data, pagination };
};

const handleReject = error => {
  // We dont have access to the store here so manually redirect.
  if (/40(1|3)/.test(error.response.status)) {
    memberStorage.remove();

    setTimeout(() => {
      window.location.pathname !== '/'
        ? window.location.assign('/')
        : error.response.config.url.includes('login') // Dont reload on failed login
          ? undefined
          : window.location.reload(true);
    });
  }

  return Promise.reject(error);
};

const getPagination = ({ config, headers = {} }) => {
  const xPagination = headers['x-pagination'];

  if (xPagination) {
    const { page } = config.params || 1;
    const pagination = camelizeKeys(JSON.parse(xPagination));

    return {
      ...pagination,
      page: parseInt(page, 10),
      perPage: Math.ceil(pagination.total / pagination.totalPages),
    };
  }
};

export const httpClient = axios.create({
  baseURL: hosts.api,
  withCredentials: true,
});

httpClient.interceptors.request.use(handleRequest);
httpClient.interceptors.response.use(handleResponse, handleReject);



// WEBPACK FOOTER //
// ./src/utils/httpClient.js